/*
Copyright 2026 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import { useEffect, useState } from "react";
import { type Room as LivekitRoom } from "livekit-client";
import { logger } from "matrix-js-sdk/lib/logger";

interface UseLivekitRoomSidParams {
  livekitRoom: LivekitRoom;
  connectionState: string;
}

/**
 * Получает server-side SID комнаты LiveKit и обновляет его при смене комнаты.
 */
export function useLivekitRoomSid({
  livekitRoom,
  connectionState,
}: UseLivekitRoomSidParams): string {
  const [callId, setCallId] = useState("");

  useEffect(() => {
    let cancelled = false;
    setCallId("");

    void livekitRoom
      .getSid()
      .then((sid) => {
        if (!cancelled) {
          setCallId(sid ?? "");
        }
      })
      .catch((error) => {
        if (!cancelled) {
          logger.warn("[CallTimer] Не удалось получить LiveKit room SID", error);
          setCallId("");
        }
      });

    return (): void => {
      cancelled = true;
    };
  }, [connectionState, livekitRoom]);

  return callId;
}
